import { styled } from '@mui/material/styles';

export const Track = styled('div')(({ theme }) => ({
  width: 24,
  height: 16,
  borderRadius: 8,
  border: 'none',
  padding: 0,
  margin: 0,
  position: 'relative',
  display: 'inline-block',
  cursor: 'pointer',
  background: theme.palette.backgroundColor,
  transition: 'background-color 180ms ease',

  appearance: 'none',
  WebkitAppearance: 'none',
  outline: 'none',

  '&[data-checked="true"]': {
    background: theme.palette.accent,
  },
}));

export const Thumb = styled('span')(({ theme }) => ({
  width: 12,
  height: 12,
  borderRadius: 999,
  position: 'absolute',
  top: 2,
  left: 2,
  background: theme.palette.light_dark,
  transition: 'transform 180ms ease, background-color 180ms ease',

  '[data-checked="true"] &': {
    transform: 'translateX(8px)',
    background: theme.palette.white_100,
  },
}));
